export default __webpack_public_path__ + "static/adhd-questions-77d9e94e21afa9479372c84bcb7a5be6.pdf";